export const CERBERUS_TITLE = "Protección de red";

export const PHONE_CALLS = "call-id";
export const SPAM_CALLS_BLOCK = "blocked-calls";
export const SPAM_FRAUD_BLOCK = "blocking-fraud-calls";
export const FRAUDULENT_SMS_BLOCKING = "fraudulent-sms-blocking";

export const RUNNING_ACTIVATED = "RUNNING_ACTIVATED";
export const ACTIVATED = "ACTIVATED";
export const RUNNING_DISABLED = "RUNNING_DISABLED";
export const DISABLED = "DISABLED";
export const RUNNING_GETINFO = "RUNNING_GETINFO";
export const ERROR = "ERROR";
export const INCOMPATIBLE = "INCOMPATIBLE";
export const NA = "NA";

export const LABEL_ACTIVATE = "Activado";
export const LABEL_ACTIVATE_BY_LAW = "Activado por ley";
export const LABEL_DESACTIVATE = "Desactivado";

export const ACTIVATION_LABEL = "Activando";
export const DESACTIVATION_LABEL = "Desactivando";

export const CALL_TITLE_SECTION = "Llamadas";
export const SMS_TITLE_SECTION = "SMS";

export const PHONE_CALLS_IDENTIFIED = "phoneCallsIdentified"
export const FRAUDULENTE_CALLS_BLOCK = "fraudulentCallsBlocked";
export const FRAUDULENTE_SMS_BLOCK = "fraudulentCallsBlocked";
export const SPAM_CALLS_BLOCK_ID = "spamCallsBlocked";
export const NO_THREATS_ID = "not-threats";

export const NO_THREATS_LABEL = "Sin amenazas";

export const CERBERUS_MODULE_TITLE = "Protección de red";
export const CERBERUS_MODULE_PHONE_CALLS = {icon: "bola-ok-l" , text:"Tienes activada la identificación de llamadas spam"};
export const CERBERUS_MODULE_BLOCK_CALLS = {icon: "bola-ok-l" , text:"Tienes activado el bloqueo de llamadas spam"};
export const CERBERUS_MODULE_NOT_ACTIVE = {icon: "ko-circle-l" , text:"No tienes activado este servicio"};
export const CERBERUS_MODULE_BLOCK_DEFAULT = {icon: "bola-ok-l" , text:"Tienes activado el bloqueo de llamadas fraudulentas"};
export const CERBERUS_MODULE_LINK = "/area-cliente/mi-perfil/informe-bloqueos";
export const CERBERUS_MODULE_LINK_LABEL = "Gestiona tu protección";

export const MODAL_ERROR_TITLE_PHONE_CALLS = "No hemos podido activar el identificador de llamadas en estas líneas";
export const MODAL_ERROR_TITLE_SPAM_CALLS = "No hemos podido activar el bloqueo en estas líneas";
export const MODAL_ERROR_TITLE_PHONE_CALLS_API = "No hemos podido activar el identificador de llamadas";
export const MODAL_ERROR_TITLE_SPAM_CALLS_API = "No hemos podido activar el bloqueo";
export const MODAL_ERROR_TITLE_SMS_FRAUD_API = "No hemos podido activar el bloqueo de SMS fraudulentos";
export const MODAL_ERROR_API = "Lo sentimos, ha ocurrido un error. Por favor, vuelve a intentarlo."
export const MODAL_ERROR_BTN = "Volver a intentarlo";
export const MODAL_BTN_DEFAULT = "Cerrar";

export const CERBERUS_CODE_ERROR_SUMMARY = 204;
export const SUMMARY_ERROR_BOX_TEXT = "No hay datos disponibles para este periodo";

export const SUMMARY_LINK_PHONE_CALLS = "Activa la identificación";
export const SUMMARY_LINK_PHONE_CALLS_SUFFIX = " para detectar amenazas";
export const SUMMARY_LINK_BLOCK_CALLS = "Activa el bloqueo";
export const SUMMARY_LINK_BLOCK_CALLS_SUFFIX = " y no recibirás llamadas spam";
export const URL_CERBERUS = "/area-cliente/mi-perfil/informe-bloqueos/";

export const NUMBERS_ES = [
  "cero",
  "una",
  "dos",
  "tres",
  "cuatro",
  "cinco",
  "seis",
  "siete",
  "ocho",
  "nueve",
  "diez",
  "once",
  "doce",
  "trece",
  "catorce",
  "quince",
  "dieciséis",
  "diecisiete",
  "dieciocho",
  "diecinueve",
  "veinte",
];

export const CERBERUS_MONTHS = {
  1: "ene",
  2: "feb",
  3: "mar",
  4: "abr",
  5: "may",
  6: "jun",
  7: "jul",
  8: "ago",
  9: "sep",
  10: "oct",
  11: "nov",
  12: "dic",
}
